import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { GenericFieldsService } from 'src/app/_shared/services/generic-fields/generic-fields.service';
import {
    SharedSubventionCriteriaGetCriteriaAction
} from 'src/app/_shared/stores/shared-subvention-criteria/shared-subvention-criteria.action';
import { ChampDto } from 'src/graphql/generated-types';

export class SharedSubventionCriteriaModel {
    criteriaList: ChampDto[] = [];
}

@Injectable()
@State({
    name: 'sharedSubventionCriterias',
    defaults: new SharedSubventionCriteriaModel()
})
export class SharedSubventionCriteriaState {

    constructor(private readonly genericFieldsService: GenericFieldsService) {
    }

    @Selector()
    public static criteriaList(state: SharedSubventionCriteriaModel): ChampDto[] {
        return state.criteriaList;
    }

    @Action(SharedSubventionCriteriaGetCriteriaAction)
    getCriterias({patchState}: StateContext<SharedSubventionCriteriaModel>): Observable<ChampDto[]> {
        return this.genericFieldsService.getGenericFieldsList$({
            TakeChampListeValeur: true,
            TakeChampTypeDonnee: true,
            IsChampCritereSub: true,
        }).pipe(
            tap(criteriaList => patchState({criteriaList}))
        );
    }

}
